import React from "react";
import { createBrowserRouter } from "react-router-dom";
import LoginScreen from "../pages/Login/login.screen";
import Dashboard from "../pages/Dashboard/Dashboard";
import EditPage from "../pages/Edit/EditPage";
import Contacts from "../pages/Contacts/Contacts";
import AdminDashboard from "../pages/Admin/AdminDashboard";
import ErrorPage from "../pages/Error/ErrorPage";
import PrivateRoutes from "./PrivateRoutes";
import Licenses from "../pages/Licenses/Licenses";
import AdminRoutes from "./AdminRoutes";
import AllChanges from "../pages/Admin/AllChangesPage/AllChanges";
import Analytics from "../pages/Admin/AnalyticsPage/Analytics";

const router = createBrowserRouter([
    {
        path: '/',
        element: <PrivateRoutes />,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                element: <Dashboard />
            },
            {
                path: "daten",
                element: <EditPage />
            },
            {
                path: "verwaltung",
                element: <AdminRoutes />,
                children: [
                    {
                        index: true,
                        element: <AdminDashboard />
                    },
                    {
                        path: "all-changes",
                        element: <AllChanges />
                    },
                    {
                        path: "analytics",
                        element: <Analytics />
                    }
                ]
            },
            {
                path: "lizenz-info",
                element: <Licenses />
            },
            {
                path: "kontakte",
                element: <Contacts />
            }
        ]
    },
    {
        path: "/login",
        element: <LoginScreen />
    }
])

export default router;
